<template>
  <div class="simulator-outer-container">
    <div class="toggle-double-mode" @click="toggleDoubleMode">
      <img src="~images/icon-plus.svg">
      {{ text }}
    </div>
    <div class="simulator-container" :class="{'double-mode': doubleMode}">
      <simulator-widget class="simulator-1" ref="simulator-1" @trigger="onTrigger" @showing="activated = true" :info="attributes.value"></simulator-widget>
      <simulator-widget class="simulator-2" ref="simulator-2" @trigger="onTrigger" :info="attributes.value"></simulator-widget>
    </div>
    <div class="simulator-disclaimer" v-if="activated">
      <p v-if="attributes.value.note" v-markdown="attributes.value.note"></p>
    </div>
  </div>
</template>

<script>
import Simulator from './Simulator.vue'

export default {
  components: {
    'simulator-widget': Simulator
  },
  props: ['attributes'],
  data () {
    return {
      activated: false,
      doubleMode: false,
      text: 'Add a school for comparison'
    }
  },
  methods: {
    toggleDoubleMode () {
      this.doubleMode = !this.doubleMode
      if (this.doubleMode) {
        this.text = 'Show only one school'
      } else {
        this.text = 'Add a school for comparison'
      }
    },
    onTrigger (target) {
      this.$refs['simulator-1'].simulate()
      if (this.doubleMode) this.$refs['simulator-2'].simulate()
    }
  }
}
</script>

<style lang="scss">
.simulator-outer-container {
  background-color: #eef3f4;
  padding: 10px 0;
  margin: 20px 0;
}

.toggle-double-mode {
  font-family: $font-CuratorRegular;
  font-size: 15px;
  cursor: pointer;
  margin: 20px 0 !important;
  text-align: center;

  img {
    width: 20px;
    height: 20px;
    vertical-align: bottom;
  }
}

.simulator-container {
  @include clearfix();
  max-width: 1200px;
  transition: all 0.3s linear;
  position: relative;

  @media only screen and (min-width: $d_medium) {
    margin: 20px auto;
  }

  &.double-mode {
    @media only screen and (max-width: $d_medium - 1) {
      .simulator-2 {
        display: block;
      }
    }

    @media only screen and (min-width: $d_medium) {
      .simulator-1 {
        transform: translateX(0%);
        border-left: 0;
        border-right: 2px dotted #ccc;
      }

      .simulator-2 {
        transform: translateX(0%);
        opacity: 1;
        height: 100%;
        overflow: initial;
        border-left: 2px dotted #ccc;
        margin-left: -2px;
        z-index: 4;
      }
    }
  }
}

.simulator {
  width: 100%;
  transition: all 0.3s linear;
  background-color: #eef3f4;

  @media only screen and (max-width: $d_medium - 1) {
    &.simulator-2 {
      display: none;
    }
  }

  @media only screen and (min-width: $d_medium) {
    width: calc(50% - 2px);
    position: relative;
    float: left;

    &.simulator-1 {
      transform: translateX(50%);
      z-index: 2;
    }

    &.simulator-2 {
      transform: translateX(-50%);
      z-index: 1;
      opacity: 0;
      height: 0;
      overflow: hidden;
    }
  }
}

.simulator-disclaimer {
  text-align: center;

  p {
    display: inline-block;
    font-family: $font-CuratorRegular;
    background-color: #FFF;
    padding: 10px 15px;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 10px;
  }
}
</style>
